export default {
      id: "ic_menu_scratch_card-usage",
      viewBox: "0 0 40 30",
      url: "/" + "images/icons.3.109.2.svg#ic_menu_scratch_card-usage",
      toString: function () {
        return this.url;
      }
    }